import React from "react";
import { AppContext } from "@lib/types/Context";
import { SharedBlockchainPaymentList } from "@app/shared";

const CustomerBlockchainPaymentList: React.FC = () => {
  return <SharedBlockchainPaymentList context={AppContext.CUSTOMER} />;
};

export default CustomerBlockchainPaymentList;
